export const QUOTE_TAG_TYPE_MAPPING = {
    industry: 'industries',
    product_review_section: 'topics', 
    strategic_question: 'themes', 
    custom: 'vendor_custom_tags'
}

export const QUOTE_TAG_TYPE_DISPLAY = {
    industries: 'By Industry',
    topics: 'By Topic',
    themes: 'By Theme',
    vendor_custom_tags: 'Custom Tags'
}

export const JSON_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

export const VENDOR_TAG_TYPE = QUOTE_TAG_TYPE_MAPPING.custom;

export const QUOTE_DELETE_POPUP_HEADER = "Delete this quote?";
export const QUOTE_DELETE_POPUP_BODY = "This change will remove this saved quote and any tags it was assigned.";
export const QUOTE_DELETE_CONFIRM = "Confirm delete";

export const TAGS_LIST_MAX_HEIGHT = "85px";

export const COMPANY_NAME = 'PeerSpot';
export const COMPANY_DOMAIN = 'peerspot.com';

export const EMAIL_PATTERN = /\S+@\S+\.\S{2,}/;
export const PASSWORD_PATTERN = /^(?=.*?[a-z])(?=.*?[0-9]).{8,70}$/i;

export const VALID_NAME_PATTERN = /^[\p{L}'.,()\-\s]+$/u;
export const GENERIC_VALIDATION_PATTERN = /^[\p{L}0-9\s'.,\-&()\/+:#@]+$/u;

export const LEADGEN_TOGGLE_RESET_TIME = 3000;

export const DEFAULT_SELECT_OPTIONS = {
    font_weight: [
        { label: 'Light', value: '300' },
        { label: 'Normal', value: '400' },
        { label: 'Medium', value: '500' },
        { label: 'Semi Bold', value: '600' },
        { label: 'Bold', value: '700' },
        { label: 'Extra Bold', value: '900' }
    ],

    text_align: [
        { label: 'Left', value: 'left' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'right' },
        { label: 'Justify', value: 'justify' },
    ],

    text_transform: [
        { label: 'None', value: null},
        { label: 'Capitalize', value: 'capitalize' },
        { label: 'Uppercase', value: 'uppercase' },
        { label: 'Lowercase', value: 'lowercase' },
    ],

    star_style: [
        { label: 'Rounded', value: 'rounded' },
        { label: 'Pointed', value: 'pointed' },
    ]
};

export const NUMBER_INPUT_CONFIG = {
    font_size: {
        step: 1,
        min: 8,
        max: 72
    },
    line_height: {
        step: 0.1,
        min: 1,
        max: 3
    },
    border_width: {
        step: 1,
        min: 0,
        max: 5
    },
    border_radius: {
        step: 1,
        min: 0,
        max: 10
    },
    padding: {
        step: 1,
        min: 10,
        max: 100
    },
};